/**
 * Scrolls the page to the section with DOM id `id` — what a sidebar jump link
 * does, and all it does: no navigation, no filter, no change to what the page
 * shows. Smooth unless the reader asked for reduced motion. A missing section
 * is a no-op.
 */
export function scrollToSection(id: string): void {
  const el = document.getElementById(id);
  if (!el) return;
  const reduce =
    typeof window.matchMedia === "function" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  el.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" });
}
